<template>
    <div class="logo">
        <img src="@/assets/logo/logo_agile.svg" alt="agile logo">
        <span class="text">Mobility Solutions</span>
    </div>
</template>

<script>
export default {
    name: "Logo",
}
</script>

<style lang="scss" scoped>
.logo{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    .text{
        font-family: 'gilroy';
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0.05em;
        color: var(--agile-black);
        margin-top: 18px;
    }
}
</style>
